// Node Modules
import ReactPlayer from 'react-player';
import React from 'react';

// Components
import MobilePhotoContainer from '@/components/global-components/photos/MobilePhotoContainer';
import DesktopPhotoContainer from '@/components/global-components/photos/DesktopPhotoContainer';
import Details from './details/Details';
import Highlights from './highlights/Highlights';
import Header from './header/Header';
import Cards from '@/components/global-components/cards/Cards';
import Container from '@/components/global-components/Container';
import Banner from '@/components/global-components/banner/Banner';
import HubspotForm from 'react-hubspot-form'
// Services
import { getProgramsContent } from '@/graphql/location';

// Queries
import { getPerfectLocationsContent } from '@/graphql/location';
// Themes
import theme from '@/themes/index';

const LocationBody = ({
  content: {
    title,
    locationName,
    images,
    highlights,
    locationDetails,
    video,
    shareText,
    photosButtonText,
    topProgramsTitle,
    programs,
    perfectLocations,
    banner,
    city,
  },
  isMobile,
  isDesktop,
}) => {
  const videos = video?.urls.map(({
    videoUrl: {
      url, 
    },
  }) => url);
  let containerStyles = {
    width: '100%', maxWidth: '944px', height: 'auto', padding: '1rem 4rem', textAlign: 'center', 
  };
  let formId = '';
  const locationForms = {
    flamingo: '2f978de2-c0c6-4589-b6f8-7ecb55466b7b',
    heredia: '691ce4f0-0259-497e-8515-ea6ee43a4018',
    monteverde: 'ec006c04-b079-485a-b3da-814adb45925e',
  }
  switch (city) {
    case 'Flamingo':
      formId = locationForms.flamingo;
      break;
    case 'Monteverde':
      formId = locationForms.monteverde;
      break;
    case 'Heredia':
      formId = locationForms.heredia;
      break;
  }

  return (
    <>
      <section className='header'>
        <Container>
          <Header
            content={{
              title, locationName, 
            }}
            shareText={shareText}
          />
        </Container>
      </section>

      {/* Images Section */}
      {images && (
        <section className='photos'>
          {!isDesktop ? (
            <MobilePhotoContainer
              images={images}
              isDesktop={isDesktop}
            />
          ) : (
            <Container>
              <DesktopPhotoContainer
                images={images}
                buttonTexts={photosButtonText}
                isDesktop={isDesktop}
              />
            </Container>
          )}
        </section>
      )}

      {/* Highlights Section */}
      {highlights && (
        <section className='highlights-form'>
          <Container style={{
            'display': 'flex',
          }}>
            <section className='highlights'>
              <Highlights content={highlights} />
            </section>
            <section className='city'>
              {/* <HubspotForm
                portalId='8617308'
                formId='2f978de2-c0c6-4589-b6f8-7ecb55466b7b'
              /> */}
            </section>
          </Container>
        </section>
      )}
      
      
      {/* Location Details Section */}
      {!!locationDetails?.length && (
        <React.Fragment>
          <Container>
            <hr />
            <section className='details'>
              <Details isDesktop={isDesktop} content={locationDetails ?? []} />
            </section>
          </Container>
        </React.Fragment>
      )}

      {/* Video Section */}
      {video && (
        <React.Fragment>
          <section className='video'>
            <hr />
            <Container>
              <ReactPlayer
                url={videos}
                height={!isDesktop ? 450 : '37.938rem'}
                width={isDesktop ? '73.875rem' : '100%'}
                style={{
                  margin: '0 auto', 
                }}
              />
            </Container>
          </section>
        </React.Fragment>
      )}
      <section className="perfect-locations">
      
        <Container>
          <Cards
            isMobile={isMobile}
            isDesktop={isDesktop}
            content={getPerfectLocationsContent(perfectLocations, title)}
          />
        </Container>
      </section>
      {/* City Top Programs Section */}
      {(programs && programs.length) && (
        <React.Fragment>
          <section className='top-programs'>
            <hr />
            <Cards
              isMobile={isMobile}
              isDesktop={isDesktop}
              content={{
                ...getProgramsContent(programs),
                title: topProgramsTitle?.replace(/{location}/g, title),
              }}
              showAlternateHeader={true}
            />
          </section>
        </React.Fragment>
      )}
      <Banner content={banner} containerStyles={containerStyles}></Banner>
      <style jsx>{`
      hr {
        margin: 0 0.625rem;
      }

      section.header {
        padding: 6rem 0.625rem 1.5rem;
      }

      section.photos,
      section.highlights-form,
      section.details,
      section.video {
        margin: 1rem 0 3rem 0;
      }

      section.top-programs {
        margin-bottom: 4rem;
      }

      section.video hr,
      section.top-programs hr {
        width: 100%;
        max-width: 87.5rem;
        margin: 0 auto 10rem;
      }

      @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
        hr {
          margin: 0;
        }

        section.header {
          padding-top: 10rem;
          padding-bottom: 1rem;
        }

        section.photos {
          padding-top: 1rem;
          padding-bottom: 2rem;
          display: flex;
          justify-content: center;
        }

        section.highlights-form {
          padding-top: 1rem;
          padding-bottom: 2rem;
          display: flex;
        }

        section.highlights,
        section.city {
          flex: 1;
          padding: 0 30px;
        }

        section.details {
          padding-top: 3rem;
        }

        section.top-programs {
           margin: 0 0 23.4375rem;
           padding: 2rem;
        }
      }
    `}</style>
    </>
  )
};

export default LocationBody;
